import { useEffect, useState, useRef } from 'react';

import ResizeObserver from 'resize-observer-polyfill';

export const useResizeObserver = (
  resizeSubject: React.MutableRefObject<HTMLElement | null>
): ResizeObserverEntry | undefined => {
  const [entry, setEntry] = useState<ResizeObserverEntry | undefined>();
  const resizeObserverRef = useRef<ResizeObserver | null>(null);

  const observe = (RO: any) => {
    resizeObserverRef.current = new RO((entries: ResizeObserverCallback) => {
      setEntry(entries[0]);
    });

    if (resizeSubject.current) {
      resizeObserverRef?.current?.observe(
        (resizeSubject.current as unknown) as Element
      );
    }
  };

  useEffect(() => {
    if ('ResizeObserver' in window) {
      observe(ResizeObserver);
    } else {
      import('resize-observer-polyfill').then(observe);
    }

    return () => {
      resizeObserverRef?.current?.unobserve(
        (resizeSubject.current as unknown) as Element
      );
    };
  }, []);

  return entry;
};
